/** Collect paginated options so form selectors do not stop at the first 50 rows. */
export async function readAllFinancialOptions<T>(
  readPage: (offset: number) => Promise<{ records: T[]; total: number; pageSize: number }>,
  signal: AbortSignal,
): Promise<T[]> {
  const records: T[] = [];
  let offset = 0;
  while (true) {
    signal.throwIfAborted();
    const page = await readPage(offset);
    signal.throwIfAborted();
    records.push(...page.records);
    offset += page.records.length;
    if (offset >= page.total || page.records.length === 0) return records;
  }
}
